<template>
  <div>
    <!-- <validation-provider
      #default="{ errors }"
      name="selectTime"
      rules="selectTimes"
    >
      <input
        v-model="selectedItem"
        type="hidden"
        name="selectTime"
      >
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider> -->
    <b-table
      small
      responsive
      borderless
      head-variant="light"
      :items="items"
      :fields="field"
      :busy="isBusy"
      show-empty
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle" />
          <strong> Load Scheduling...</strong>
        </div>
      </template>
      <template
        #head()="data"
      >
        <div class="custom-check d-flex flex-column my-1">
          <b-form-checkbox
            v-model="timeSelected[data.label]"
            :value="trueVal(data.label)"
            :unchecked-value="falseVal(data.label)"
            class="custom-control-danger"
            @change="setTimeSelect"
          >
            <span>{{ data.label }}</span>
          </b-form-checkbox>
        </div>
      </template>
      <template #head(day)="data">
        <div class="custom-check d-flex flex-column my-1">
          <b-form-checkbox
            v-model="allSelected"
            class="custom-control-danger wd-100"
            @change="setAllSelected"
          >
            <span>{{ data.label }}</span>
          </b-form-checkbox>
        </div>
      </template>
      <template #cell()="data">
        <div
          v-if="(typeof(data.item[data.field.key]) !== 'undefined')"
          class="custom-check d-flex flex-column"
        >
          <b-form-checkbox
            v-model="selectedItem"
            :value="data.item[data.field.key]"
            :disabled="setDisableSchedule(data.item[data.field.key])"
            class="custom-control-danger"
            style="margin-bottom: 1.3rem !important"
            @change="getTotalPrice()"
          />
          <div>
            <span class="font-small-1">
              <!-- {{ data.item[data.field.key].price }} -->
            </span>
          </div>
        </div>
        <div
          v-if="(typeof(data.item[data.field.key]) === 'undefined')"
          class="custom-check d-flex flex-column"
        >
          <b-form-checkbox
            disabled
            class="custom-control-danger"
          />
          <div>
            <span class="font-small-1">0</span>
          </div>
        </div>
      </template>

      <template #cell(day)="data">
        <div class="custom-check d-flex flex-column">
          <b-form-checkbox
            v-model="daySelected[data.index]"
            :value="trueVal(data.index)"
            :unchecked-value="falseVal(data.index)"
            class="custom-control-danger"
            @change="setDaySelect"
          >
            <b>{{ data.value }}</b>
            <div>
              <span class="font-small-1">{{ data.item['8am'].date }}</span>
            </div>
          </b-form-checkbox>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import {
  BTable,
  BFormCheckbox,
  BSpinner,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
// import {
//   ValidationProvider,
//   extend,
// } from 'vee-validate'

// extend('selectTimes', value => {
//   if (value.length !== 0) return true
//   return 'Select time is required'
// })

export default {
  components: {
    BTable,
    BFormCheckbox,
    BSpinner,
    // ValidationProvider,
  },
  props: {
    // eslint-disable-next-line
    items: Array,
    // eslint-disable-next-line
    field: Array,
  },
  data() {
    return {
      selectedItem: [],
      timeSelected: {},
      timeDisabled: [],
      timeSelectedArr: {
        '12am': [],
        '1am': [],
        '2am': [],
        '3am': [],
        '4am': [],
        '5am': [],
        '6am': [],
        '7am': [],
        '8am': [],
        '9am': [],
        '10am': [],
        '11am': [],
        '12pm': [],
        '1pm': [],
        '2pm': [],
        '3pm': [],
        '4pm': [],
        '5pm': [],
        '6pm': [],
        '7pm': [],
        '8pm': [],
        '9pm': [],
        '10pm': [],
        '11pm': [],
      },
      daySelectedTime: [
        '12am',
        '1am',
        '2am',
        '3am',
        '4am',
        '5am',
        '6am',
        '7am',
        '8am',
        '9am',
        '10am',
        '11am',
        '12pm',
        '1pm',
        '2pm',
        '3pm',
        '4pm',
        '5pm',
        '6pm',
        '7pm',
        '8pm',
        '9pm',
        '10pm',
        '11pm',
      ],
      daySelectedArr: {},
      daySelectedList: [],
      daySelected: {},
      allSelected: false,
      allSelectedArr: [],
      isBusy: false,
    }
  },
  mounted() {
    // console.log(this.field)
    // console.log(this.items)
    // let arrItem = Object.keys(this.items)
    // console.log(arrItem)
    // let fields = this.items.map(item => item.key)
  },
  methods: {
    ...mapActions('ratecard', [
      'getScheduling',
    ]),
    getData() {
      this.isBusy = true
      this.getScheduling().then(() => {
        this.isBusy = false
      })
    },
    resetData() {
      // console.log(this.selectedItem)
      this.selectedItem = []
      this.allSelectedArr = []
      this.timeDisabled = []
      this.timeSelected = {}
      this.daySelected = {}
      this.allSelected = false
      this.getTotalPrice()
    },
    setSchedule() {
      let buff = window.btoa(JSON.stringify(this.selectedItem))
      // this.$store.state.campaign.formCampaign.scheduling.rate_card_id = Buffer.from(JSON.stringify(this.selectedItem), 'base64')
      this.$store.state.campaign.formCampaign.scheduling.rate_card_id = buff
      // console.log(buff, 'base64')
      this.getTotalPrice()
    },
    setTimeSelect(e) {
      if (e.status !== false) {
        this.items.forEach(item => {
          if (typeof (item[e.name]) !== 'undefined') {
            if (item[e.name].disabled === 0) {
              this.timeSelectedArr[e.name].push(item[e.name])
              this.selectedItem.push(item[e.name])
            }
          }
        })
      } else {
        const a = this.selectedItem.filter(item => !this.timeSelectedArr[e.name].includes(item))
        this.selectedItem = a
      }
      // eslint-disable-next-line no-unused-expressions
      [...new Set(this.selectedItem)]
      this.selectedItem = this.getRemove(this.selectedItem)
      this.getTotalPrice()
    },
    setDaySelect(e) {
      if (e.status !== false) {
        this.daySelectedTime.forEach(key => {
          if (typeof (this.items[e.name][key]) !== 'undefined') {
            if (this.items[e.name][key].disabled === 0) {
              this.selectedItem.push(this.items[e.name][key])
              this.daySelectedList.push(this.items[e.name][key])
            }
          }
        })
        this.daySelectedArr[e.name] = this.daySelectedList
        this.daySelectedList = []
      } else {
        const a = this.selectedItem.filter(item => !this.daySelectedArr[e.name].includes(item))
        this.selectedItem = a
      }
      // eslint-disable-next-line no-unused-expressions
      [...new Set(this.selectedItem)]
      this.selectedItem = this.getRemove(this.selectedItem)
      this.getTotalPrice()
    },
    setAllSelected(e) {
      this.timeSelected = {}
      if (e) {
        const itemLen = this.items.length
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < itemLen; i++) {
          this.daySelected[i] = (this.trueVal(i))
          this.setDaySelect(this.daySelected[i])
        }
        this.daySelectedTime.forEach(key => {
          this.timeSelected[key] = (this.trueVal(key))
          this.allSelectedArr.push(this.timeSelected[key])
        })
        this.allSelectedArr.forEach(item => {
          this.setTimeSelect(item)
        })
      } else {
        this.allSelectedArr.forEach(key => {
          const a = this.selectedItem.filter(item => !this.timeSelectedArr[key.name].includes(item))
          this.selectedItem = a
        })
        this.allSelectedArr = []
        this.timeSelected = {}
        this.daySelected = {}
      }
      // eslint-disable-next-line no-unused-expressions
      [...new Set(this.selectedItem)]
      this.selectedItem = this.getRemove(this.selectedItem)
      this.getTotalPrice()
    },
    trueVal(data) {
      const val = {
        name: data,
        status: true,
      }
      return val
    },
    falseVal(data) {
      const val = {
        name: data,
        status: false,
      }
      return val
    },
    getTotalPrice() {
      // eslint-disable-next-line radix
      const data = this.selectedItem.reduce((accumulator, current) => accumulator + parseInt(current.price), 0)
      this.$store.state.campaign.formCampaign.forcasted_price = data
    },
    setDisableSchedule(ser) {
      // console.log(ser, 'ddd')
      let setObj = ser
      if (typeof ser !== 'undefined') {
        // console.log(ser, 'udiiii')
        setObj.disabled = 1
        if (!ser.isDisabled) {
          setObj.disabled = 0
        }
        return ser.isDisabled
      }
      // setObj.disabled = 0
      // console.log('udiiii')
      return false
    },
    // getlimitTime(ser) {
    //   let setObj = ser
    //   let timex = setObj.time
    //   // eslint-disable-next-line radix
    //   let hours = parseInt(timex.substr(0, 2))
    //   if (timex.indexOf('am') !== -1 && hours === 12)timex = timex.replace('12', '0')
    //   if (timex.indexOf('pm') !== -1 && hours < 12)timex = timex.replace(hours, (hours + 12))
    //   timex = timex.replace(/(am|pm)/, '')
    //   timex = `${ser.date} ${(`0${timex}`).slice(-2)}:00`
    //   let lisTime = new Date(timex).getTime()
    //   let thisTime = new Date().getTime()
    //   let has = lisTime - (thisTime - 3600000)
    //   setObj.disabled = 0
    //   if (has < 0) {
    //     setObj.disabled = 1
    //   }
    //   return !(has > 0)
    // },
    getRemove(listOfTags) {
      const keys = ['date', 'time']
      const filtered = listOfTags.filter(
        (s => o => (k => !s.has(k) && s.add(k))(keys.map(k => o[k]).join('|'))
        )(new Set()),
      )
      return filtered
    },
  },
}
</script>

<style scoped>
.table th {
padding: 0.5rem 1.5rem !important;
}
.table td {
padding: 0.5rem 1.5rem !important;
}
.wd-100 {
  min-width: 100px !important;
}
</style>
